var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashedLines = function SvgDashedLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v4m0 1v4m0 1v4m0 1v4m0 1v4",
    stroke: "#003E52",
    fill: "none",
    fillRule: "evenodd"
  })));
};
export default SvgDashedLines;